import { call, params, options } from './helpers';

// Get all tasks with filters and pagination
export const getTasks = (payload) => call(`/beta/tasks${params(payload)}`);

// Get all tasks assigned to the current user
export const getMyTasks = (payload) => call(`/beta/tasks/my${params(payload)}`);

// Get tasks with due dates for calendar view
export const getTasksCalendar = (payload) => call(`/beta/tasks/calendar${params(payload)}`);

// Get a single task by ID
export const getTask = (id) => call(`/beta/tasks/${id}`);

// Create a new task
export const createTask = (payload) => call('/beta/tasks', options(payload, 'POST'));

// Update a task
export const updateTask = (id, payload) => call(`/beta/tasks/${id}`, options(payload, 'PUT'));

// Delete a task
export const deleteTask = (id) => call(`/beta/tasks/${id}`, options(null, 'DELETE'));

// Skip a task
export const skipTask = (id) => call(`/beta/tasks/${id}/skip`, options(null, 'POST'));

// ===== Subtasks =====

// Get subtasks for a task
export const getSubtasks = (taskId) => call(`/beta/tasks/${taskId}/subtasks`);

// Create a subtask
export const createSubtask = (taskId, payload) =>
	call(`/beta/tasks/${taskId}/subtasks`, options(payload, 'POST'));

// ===== Documents =====

// Get documents for a task
export const getTaskDocuments = (taskId) => call(`/beta/tasks/${taskId}/documents`);

// Add documents to a task (link existing document IDs)
export const addTaskDocuments = (taskId, payload) =>
	call(`/beta/tasks/${taskId}/documents`, options(payload, 'POST'));

// Upload files to a task
export const uploadTaskDocuments = async (taskId, files, documentIds = []) => {
	const formData = new FormData();

	// Add files to upload
	files.forEach((file) => {
		formData.append('files', file);
	});

	// Add document IDs to link (if any)
	if (documentIds.length > 0) {
		formData.append('documentIds', JSON.stringify(documentIds));
	}

	const user = JSON.parse(localStorage.getItem('user'));

	const response = await fetch(`${process.env.API_URL}/beta/tasks/${taskId}/documents`, {
		method: 'POST',
		headers: {
			...(user?.jwtToken ? { Authorization: `Bearer ${user.jwtToken}` } : {}),
		},
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Failed to upload documents');
	}

	return response.json();
};

// Remove a document from a task
export const removeTaskDocument = (taskId, documentId) =>
	call(`/beta/tasks/${taskId}/documents/${documentId}`, options(null, 'DELETE'));

// ===== SOPs =====

// Attach an SOP to a task
export const attachTaskSop = (taskId, sopId) =>
	call(`/beta/tasks/${taskId}/sop`, options({ sopId }, 'POST'));

// Remove SOP from a task
export const removeTaskSop = (taskId) =>
	call(`/beta/tasks/${taskId}/sop`, options(null, 'DELETE'));

// Save SOP responses for a task
export const saveTaskSopResponses = (taskId, payload) =>
	call(`/beta/tasks/${taskId}/sop/responses`, options(payload, 'POST'));

// ===== Recurrence Rules =====

// Get all recurrence rules
export const getRecurrenceRules = (payload) =>
	call(`/beta/task-recurrence-rules${params(payload)}`);

// Get a single recurrence rule
export const getRecurrenceRule = (id) => call(`/beta/task-recurrence-rules/${id}`);

// Create a recurrence rule (creates rule + first task)
export const createRecurrenceRule = (payload) =>
	call('/beta/task-recurrence-rules', options(payload, 'POST'));

// Update a recurrence rule
export const updateRecurrenceRule = (id, payload) =>
	call(`/beta/task-recurrence-rules/${id}`, options(payload, 'PUT'));

// Delete (deactivate) a recurrence rule
export const deleteRecurrenceRule = (id) =>
	call(`/beta/task-recurrence-rules/${id}`, options(null, 'DELETE'));

// Get tasks generated by a recurrence rule
export const getRecurrenceRuleTasks = (id, payload) =>
	call(`/beta/task-recurrence-rules/${id}/tasks${params(payload)}`);

// Generate a task from a recurrence rule immediately
export const generateRecurrenceRuleTask = (id) =>
	call(`/beta/task-recurrence-rules/${id}/generate`, options(null, 'POST'));
